import { render, staticRenderFns } from "./input-radio.vue?vue&type=template&id=12e61eca&"
import script from "./input-radio.vue?vue&type=script&lang=js&"
export * from "./input-radio.vue?vue&type=script&lang=js&"
import style0 from "./input-radio.vue?vue&type=style&index=0&id=12e61eca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports